import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { _throw } from "rxjs/observable/throw";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { ApiObjectFacade } from "../api-object/api-object.facade";
import { ControlTypeApiFacade } from "./control-type.api-facade";
import { ControlType } from "./control-type.model";
import { ControlTypeStoreFacade } from "./control-type.store-facade";

export class ControlTypeFacade extends ApiObjectFacade<ControlType, ControlTypeApiFacade, ControlTypeStoreFacade> {

    syncOne(id: string, options?: ApiRequestOptions): Observable<any> {
        if (this.appFacade.objects.isChangePending(id)) {
            return of(undefined);
        }

        return this.api.get(id, options)
            .catch(error => {
                if (error.status === 404) {
                    this.store.get(id)
                        .take(1)
                        .do(item => {
                            this.store.remove(item, {persistable: true, restful: false});
                        })
                        .subscribe(item => undefined);
                    return of(undefined);
                } else {
                    return _throw(error);
                }
            })
            .do(object => this.insertIfFresher(object));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.facade.ts